export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7739.f0a28436.jpg";